'use strict';

var parent = require('../../stable/map');
require('../../modules/esnext.map.get-or-insert');
require('../../modules/esnext.map.get-or-insert-computed');
require('../../modules/esnext.map.group-by');
module.exports = parent;